<template>
  <v-container>
      <v-layout>
        <v-flex>
            <div class="appUnderwriterText">
              <span v-html="underwriterVerbiage"></span>
            </div>
        </v-flex>
      </v-layout>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import urlUtils from 'utils/url';

export default {
  name: 'TheUnderwriterText',
  props: {
    type: {
      type: String,
      default: 'recharge',
    },
    state: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapGetters(['urlParams']),
    ...mapGetters('widgetData', ['widgetData']),
    underwriterVerbiage() {
      const {
        // eslint-disable-next-line camelcase
        links, underwriter, widget_legal_content, policy_pdf,
      } = this.widgetData;
      const product = urlUtils.getProductFromDomain();
      let { url: tcLink } = links.filter(link => link.type.toLowerCase() === 't&c')[0] || '';
      if (
        product === 'enhancedrefundprogram'
        || product === 'raas'
      ) {
        // eslint-disable-next-line camelcase
        tcLink = policy_pdf;
      }
      const { url: ppLink } = links.filter(link => link.type.toLowerCase() === 'privacy')[0] || '';
      const { url: insuranceLink } = links.filter(link => link.type.toLowerCase() === 'refundterms')[0] || '';

      let legalVerbiageToDisplay = '';

      const linkVerbiages = `<br/>
        <br/>
        <div style="display: flex;justify-content: space-evenly;">
          <a class="underwriterAnchorText" href="${tcLink}"  target="_blank">Terms and Conditions</a>
          <a class="underwriterAnchorText" href="${ppLink}" target="_blank">Privacy Policy</a>
          ${insuranceLink ? `<a class="underwriterAnchorText" href="${insuranceLink}" target="_blank">Insurance Terms</a>` : ''}
        </div>`;

      // eslint-disable-next-line camelcase
      if (widget_legal_content) return widget_legal_content + linkVerbiages;

      switch (underwriter.name) {
        case 'Markel':
          legalVerbiageToDisplay = 'By submitting your purchase you agree to the terms below and consent to processing of your personal information in accordance with Protecht\'s Privacy Policy. This policy is underwritten by the licensed insurance carrier identified in the insurance terms below.';
          break;
        case 'Amtrust':
          legalVerbiageToDisplay = 'By submitting your purchase you agree to the terms below and consent to processing of your personal information in accordance with Protecht\'s Privacy Policy. This policy is underwritten by the licensed insurance carrier identified in the insurance terms below.';
          break;
        case 'Technology Insurance Company, Inc. (Canada)':
          legalVerbiageToDisplay = 'By submitting your purchase, you agree to the terms and Privacy Policy below and consent to the processing of your personal information according to the Privacy Policy. This protection product is underwritten by Technology Insurance Co., a prudentially regulated insurance company, and sold to you by Insurance Insight Inc. a licensed broker in your province.';
          break;
        case 'JSV':
          legalVerbiageToDisplay = 'By submitting your purchase, you agree to the terms below and consent to processing of your personal information in accordance with Privacy Policy. The "Global Refund Programme" is a JSV Events Limited Program (UK FCA No. 781604 - Company Number 10712264) with refunds administered by VeriClaim, Inc./Sedgwick CMS. Technology powered by FanShield International, LLC.';
          break;
        default:
          break;
      }

      return legalVerbiageToDisplay + linkVerbiages;
    },
  },
};
</script>

<style>
.appUnderwriterText {
  width: 1068px;
  font-family: Gotham;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.43;
  letter-spacing: normal;
  text-align: left;
  color: #333333;
  margin: 0 auto;
  padding-bottom: 20px;
}

.underwriterAnchorText {
  font-family: Gotham;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.43;
  letter-spacing: normal;
  color: #333;
}

 /* Extra large Break Point */
@media screen and (min-width: 1904px) {
  .appUnderwriterText {
    width: 1160px;
  }
}

 /* Tablet Break Point */
@media screen and (max-width: 1264px) {
  .appUnderwriterText {
    width: 675px;
  }
}

/* Mobile Break Point */
@media screen and (max-width: 767px) {
  .appUnderwriterText {
    width: 269px;
    height: auto;
  }
}
</style>
